import { render, staticRenderFns } from "./ApproveInvoiceReviewModal.vue?vue&type=template&id=f4843a28&scoped=true"
import script from "./ApproveInvoiceReviewModal.vue?vue&type=script&lang=js"
export * from "./ApproveInvoiceReviewModal.vue?vue&type=script&lang=js"
import style0 from "./ApproveInvoiceReviewModal.vue?vue&type=style&index=0&id=f4843a28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4843a28",
  null
  
)

export default component.exports